/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Waterefrconsumption2Inputs */



/**
* | output |
* | --- |
* | "Filling cold water consumption" |
*
* @param {Br_History_Key_Waterefrconsumption2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_waterefrconsumption2 = /** @type {((inputs?: Br_History_Key_Waterefrconsumption2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Waterefrconsumption2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Filling cold water consumption")
	return /** @type {LocalizedString} */ ("Consommation d'eau froide de remplissage")
});
export { br_history_key_waterefrconsumption2 as "br_history_key_waterEfrConsumption" }